/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.FundMyAccountResponse | undefined,
  (params: FundMyAccount) => void,
  () => void,
  (params: FundMyAccount) => Promise<vp.FundMyAccountResponse>,
];
export type FundMyAccount = {
  Token: string;
  Currency: string;
  ClientAccountID?: string;
  Amount: number;
  ClientReferenceNumber?: string;
  Notes?: string;
};

function usePostFundMyAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<FundMyAccount>();
  const [response, setResponse] = useState<vp.FundMyAccountResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: FundMyAccount) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const responseWithdraw = await api.postFundMyAccount(
        {
          Amount: requestParams.Amount || 0,
          Currency: requestParams.Currency,
          ClientReferenceNumber: requestParams.ClientReferenceNumber,
          Notes: requestParams.Notes,
          ClientAccountID: requestParams.ClientAccountID,
        },
        source,
      );

      setResponse(responseWithdraw);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: FundMyAccount) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
    async (requestParams: FundMyAccount) => {
      const responseWithdraw = await api.postFundMyAccount(
        {
          Amount: requestParams.Amount || 0,
          Currency: requestParams.Currency,
          ClientReferenceNumber: requestParams.ClientReferenceNumber,
          Notes: requestParams.Notes,
          ClientAccountID: requestParams.ClientAccountID,
        },
        source,
      );
      return responseWithdraw;
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostFundMyAccount);
